import { connect } from 'react-redux';
import { postDaoHo, setDaoHo } from 'actions/TraGop/DaoHo';
import DaoHo from 'components/CommonComponent/DaoHo';

const mapStateToProps = (state) => ({
  daoho: state.daoho,
  phanquyen: state.phanquyen,
  phikhac: state.phikhac,
});

const mapDispatchToProps = (dispatch) => ({
  postDaoHo: (dataPost) => dispatch(postDaoHo(dataPost)),
  setDaoHo: (data) => dispatch(setDaoHo(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DaoHo);
